import "./Contact.scss";
import logo from "../../assets/images/logo-png/ret2.png";
import InstagramIcon from "utils/icons/InstagramIcon";
import LinkedinIcon from "utils/icons/LinkedinIcon";
import { handleClickSchedule } from "Helper";

const Contact = () => (
  <section id="contact">
    <footer className="footer">
      <div className="container">
        <div className="contactInfo">
          <h2>Contato</h2>
          <p>
            Email: <a href="mailto:atendimento@sodalitabemestar.com.br" id="mail-contact-footer">atendimento@sodalitabemestar.com.br</a>
          </p>
          <p>
            Telefone: <a onClick={handleClickSchedule} id="whatsapp-contact-footer">(47) 9 8912-9295</a>
          </p>
        </div>
        <div className="socialMedia">
          <h2>Sigam-nos</h2>
          <div className="iconsContainer">
            <a
              href="https://www.instagram.com/sodalitabemestar"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon size={50} />
            </a>
            <a
              href="https://www.linkedin.com/company/sodalita-bem-estar-corporativo"
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedinIcon size={35} />
            </a>
          </div>
        </div>
      </div>
      <div className="footerBottom">
        {/* <p style={{ marginBottom: 5 }}>Desenvolvido por GS Bernardi</p> */}
        <img src={logo} alt="SPA Energético" style={{ width: 120 }} />
      </div>
    </footer>
  </section>
);

export default Contact;
